export default __webpack_public_path__ + "static/media/Banner - AirLockz - White.856aaaa1.jpg";